<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>
          Cargar información{{ editedItem.nombre_puesto ? `: ${editedItem.nombre_puesto}` : '' }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon :disabled="loadingSave" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container fluid style="max-width: 1800px !important">
          <div class="pa-3 ma-3">
      <v-alert-dialog ref="alert"></v-alert-dialog>
      <v-dialog
        v-model="dialogComplete"
        max-width="50%"
        persistent
      >
        <v-card>
          <v-card-text class="text-center">
            <v-icon
              size="300"
              color="green"
            >
              mdi-check-circle
            </v-icon>
            <div class="text-h5">
              Documentación recibida. Su información está en validación. Recibirá un correo con la confirmación o con las indicaciones para corregir algún documento.
            </div>
            <br>      
            <v-btn
              block
              color="green"
              class="white--text"
              @click="cerrarDialogo"
            >
              Aceptar
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-row
        v-if="!loading"
        class="pa-0 ma-0"
      >
        <v-col cols="12" class="pa-0 ma-0 text-center">
          <div class="text-subtitle-1 font-weight-bold">
            <v-icon>mdi-account</v-icon>
            Datos Personales
          </div>
        </v-col>

        <!-- DATOS PERSONALES -->
        <v-col cols="4">
          <div class="text-subtitle-2">Nombre:</div>
          <div>{{ editedItem.nombre }}</div>
        </v-col>
        <v-col cols="4">
          <div class="text-subtitle-2">Apellido paterno:</div>
          <div>{{ editedItem.apellido_paterno }}</div>
        </v-col>

        <v-col cols="4">
          <div class="text-subtitle-2">Apellido materno:</div>
          <div>{{ editedItem.apellido_materno }}</div>
        </v-col>

        <v-col cols="4">
          <div class="text-subtitle-2">Fecha de nacimiento:</div>
          <div>{{ editedItem.fecha_nacimiento_beauty || editedItem.fecha_nacimiento }}</div>
        </v-col>

        <v-col cols="4">
          <div class="text-subtitle-2">Género:</div>
          <div>{{ editedItem.genero == 0 ? 'Femenino' : 'Masculino' }}</div>
        </v-col>

        
        <v-col cols="4">
          <!--
          <div class="text-subtitle-2">Estado civil:</div>
          <div>{{ editedItem.nombre_estado_civil || 'N/D' }}</div>
          -->
          <!-- solicitud_aceptada && ids_campos_adicionales.Contains(1) -->
          <v-autocomplete
            v-model="editedItem.id_estado_civil"
            :items="estadosCivilesLegales"
            item-value="id_estado_civil"
            item-text="nombre"
            label="Estado civil *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(1)"
          >
          </v-autocomplete>
        </v-col>

        <!-- IDENTIFICACIONES -->
        <v-col cols="4">
          <div class="text-subtitle-2">CURP:</div>
          <div>{{ editedItem.curp_valor }}</div>
        </v-col>

        <v-col cols="4">
          <div class="text-subtitle-2">RFC:</div>
          <div>{{ editedItem.rfc_valor }}</div>
        </v-col>

        <v-col cols="4">
          <!--
          <div class="text-subtitle-2">Número de Seguridad Social:</div>
          <div>{{ editedItem.nss_valor || 'N/D' }}</div>
          -->
          <!-- solicitud_aceptada && ids_campos_adicionales.Contains(2) -->
          <v-text-field
            v-model="editedItem.nss_valor"
            label="Número de Seguridad Social *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(2)"
          />
        </v-col>

        <!--
        <v-col cols="3">
          <div class="text-subtitle-2">No. trabajador (NOI):</div>
          <div>{{ editedItem.noi_numero_trabajador || 'N/D' }}</div>
        </v-col>
        <v-col cols="6">
        </v-col>
        -->

        <v-col
          cols="12"
          class="pb-0 mb-0 text-center"
        >
          <div class="text-subtitle-1 font-weight-bold">
            <v-icon>
              mdi-phone
            </v-icon>
            Datos de Contacto
          </div>
        </v-col>

        <!-- solicitud_aceptada && ids_campos_adicionales.Contains(3) -->
        <!-- CONTACTO -->
        <v-col cols="6">
          <v-text-field
            v-model="editedItem.direccion"
            label="Dirección *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model="editedItem.num_exterior"
            label="# Exterior *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model="editedItem.num_interior"
            label="# Interior"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model="editedItem.colonia"
            label="Colonia *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model="editedItem.cp"
            label="Código postal *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="3">
          <v-autocomplete
            v-model="editedItem.id_estado"
            :items="estados"
            outlined
            label="Estado *"
            item-text="nombre"
            item-value="id_estado"
            @change="changeEstado"
            :loading="loadingEstados"
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          >
          </v-autocomplete>
        </v-col>
                    
        <v-col cols="3">
          <v-autocomplete
            v-model="editedItem.id_municipio"
            :items="municipios"
            item-text="nombre"
            item-value="id_municipio"
            outlined
            label="Municipio *"
            :loading="loadingMunicipios"
            :disabled="campoAdicionalDeshabilitado(3) || editedItem.id_estado == null || editedItem.id_estado <= 0 || loadingMunicipios"
            dense
            hide-details
          >
          </v-autocomplete>
        </v-col>



        <v-col cols="6">
          <v-autocomplete-telefono
            v-model="editedItem.telefono"
            label="Teléfono de contacto *"
            url-get="/Catalogos/ListarPaises"
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="editedItem.email"
            label="Email de contacto *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="editedItem.nombre_contacto_emergencia"
            label="Nombre completo del contacto de emergencia *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>

        <v-col cols="6">
          <v-autocomplete-telefono
            v-model="editedItem.telefono_contacto_emergencia"
            label="Número de celular del contacto de emergencia *"
            url-get="/Catalogos/ListarPaises"
            :disabled="campoAdicionalDeshabilitado(3)"
          />
        </v-col>
        <!-- termina solicitud_aceptada && ids_campos_adicionales.Contains(3) -->

        <!-- INFORMACIÓN LABORAL -->
        <v-col
          cols="12"
          class="pb-0 mb-0 text-center"
        >
          <div class="text-subtitle-1 font-weight-bold">
            <v-icon>
              mdi-briefcase
            </v-icon>
            Información Laboral
          </div>
        </v-col>

        <v-col cols="12">
          <div class="text-subtitle-2">Puesto:</div>
          <div>{{ editedItem.nombre_puesto }}</div>
        </v-col>

        <!--
        <v-col cols="4">
          <div class="text-subtitle-2">Fecha de alta:</div>
          <div>{{ editedItem.fecha_alta }}</div>
        </v-col>

        <v-col cols="4">
            <div class="text-subtitle-2">Sueldo quincenal bruto:</div>
            <div>{{ editedItem.sueldo_bruto_quincenal != null ? formatMoney(editedItem.sueldo_bruto_quincenal) : 'N/D' }}</div>
        </v-col>
        -->

        <!-- INFORMACIÓN LEGAL/FISCAL -->
        <!-- solicitud_aceptada && ids_campos_adicionales.Contains(4) -->
        <v-col
          cols="12"
          class="pb-0 mb-0 text-center"
        >
          <div class="text-subtitle-1 font-weight-bold">
            <v-icon>
              mdi-scale-balance
            </v-icon>
            Información Legal/Fiscal
          </div>
        </v-col>

        <v-col cols="4">
          <!--
          <div class="text-subtitle-2">¿Tiene activo el régimen de sueldos y salarios e ingresos asimilados a salarios?:</div>
          <div>{{ (editedItem.regimen_sueldos != null) ? (editedItem.regimen_sueldos ? 'Sí' : 'No') : 'N/D' }}</div>
          -->

          <v-select
            v-model="editedItem.regimen_sueldos"
            :items="siNoOptions"
            label="¿Tiene activo el régimen de sueldos y salarios e ingresos asimilados a salarios? *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(4)"
          />
        </v-col>

        <!--
        <v-col cols="3">
          <div class="text-subtitle-2">Estado civil [Contrato y Aspectos Legales]:</div>
          <div>{{ editedItem.nombre_estado_civil_legal || 'N/D' }}</div>
        </v-col>
        -->

        <v-col cols="4">
          <!--
          <div class="text-subtitle-2">¿Tiene algún crédito u obligación legal que afecte su nómina?:</div>
          <div>{{ (editedItem.tiene_credito != null) ? (editedItem.tiene_credito ? 'Sí' : 'No') : 'N/D' }}</div>
          -->
          <v-select
            v-model="editedItem.tiene_credito"
            :items="siNoOptions"
            label="¿Tiene algún crédito u obligación legal que afecte su nómina? *"
            outlined
            dense
            hide-details
            @change="changeCredit"
            :disabled="campoAdicionalDeshabilitado(4)"
          />
        </v-col>

        <v-col cols="4">
          <!--
          <div class="text-subtitle-2">Tipo de crédito u obligación legal:</div>
          <div>{{ (editedItem.nombres_tipo_credito != null && editedItem.nombres_tipo_credito.length > 0) ? (editedItem.nombres_tipo_credito || []).join(', ') : 'N/A' }}</div>
          -->
          <v-autocomplete
            v-model="editedItem.ids_tipo_credito"
            :items="creditoTipos"
            item-value="id_rh_credito_tipo"
            item-text="nombre"
            label="Tipo de crédito u obligación legal"
            outlined
            dense
            hide-details
            multiple
            chips
            deletable-chips
            :disabled="campoAdicionalDeshabilitado(4) || editedItem.tiene_credito !== true"
          />
        </v-col>

        <v-col cols="12">
          <v-simple-table dense class="mb-2">
            <thead>
              <tr>
                <th class="text-left" style="width: 30%">Nombre completo del beneficiario (mayor de 18 años)</th>
                <th class="text-left" style="width: 30%">Número de celular del beneficiario</th>
                <th class="text-left" style="width: 30%">Parentesco del beneficiario</th>
                <th style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in editedItem.beneficiarios" :key="'beneficiario-' + i">
                <td>
                  <v-text-field
                    v-model="row.nombre_completo"
                    dense
                    outlined
                    hide-details
                    class="my-2"
                    label="Nombre completo *"
                    :disabled="campoAdicionalDeshabilitado(4)"
                  />
                </td>
                <td>
                  <v-autocomplete-telefono
                    v-model="row.telefono"
                    label="Número de celular *"
                    url-get="/Catalogos/ListarPaises"
                    :disabled="campoAdicionalDeshabilitado(4)"
                  />
                </td>
                <td>
                  <v-autocomplete
                    v-model="row.id_parentesco"
                    label="Parentesco *"
                    :items="parentescos"
                    item-text="nombre"
                    item-value="id_parentesco"
                    dense
                    hide-details
                    outlined
                    :disabled="campoAdicionalDeshabilitado(4)"
                  />
                </td>
                <td class="text-center">
                  <v-btn icon small :disabled="campoAdicionalDeshabilitado(4)" @click="removeBeneficiario(i)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-btn small outlined :disabled="campoAdicionalDeshabilitado(4)" @click="addBeneficiario">
            <v-icon left small>mdi-plus</v-icon>Agregar beneficiario
          </v-btn>
        </v-col>
        <!-- termina solicitud_aceptada && ids_campos_adicionales.Contains(4) -->


        <!-- solicitud_aceptada && ids_campos_adicionales.Contains(5) -->
        <v-col cols="12" class="pb-0 mb-0 text-center">
          <div class="text-subtitle-1 font-weight-bold">
            <v-icon>mdi-bank-outline</v-icon>
            Cuentas bancarias
          </div>
        </v-col>

        <v-col cols="6">
          <div class="text-subtitle-2">Nombre del beneficiario:</div>
          <div>{{ editedItem.cuenta_bancaria.nombre_beneficiario || `${editedItem.nombre} ${editedItem.apellido_paterno} ${editedItem.apellido_materno}` }}</div>
        </v-col>

        <v-col cols="6">
          <div class="text-subtitle-2">Moneda:</div>
          <div>{{ editedItem.cuenta_bancaria.moneda || 'Pesos Mexicanos' }}</div>
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            v-model="editedItem.cuenta_bancaria.id_banco"
            :items="bancos"
            :item-text="codigoNombre"
            item-value="id_banco"
            label="Banco *"
            outlined
            dense
            hide-details
            :loading="loadingBancos"
            :disabled="campoAdicionalDeshabilitado(5)"
          />
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="editedItem.cuenta_bancaria.clave_int"
            label="CLABE interbancaria *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(5)"
          />
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="editedItem.cuenta_bancaria.cuenta"
            label="Número de cuenta *"
            outlined
            dense
            hide-details
            :disabled="campoAdicionalDeshabilitado(5)"
          />
        </v-col>

        <v-col
          v-if="editedItem.cuenta_bancaria.observacion != null"
          cols="6"
          class="align-self-center"
        >
          <div class="red--text">
            Motivo de rechazo: {{ editedItem.cuenta_bancaria.observacion }}
          </div>
        </v-col>

        <!--
        <v-col cols="4">
          <v-text-field
            v-model="editedItem.cuenta_bancaria.cie"
            label="CIE"
            outlined
            dense
            hide-details
          />
        </v-col>

        <v-col cols="4">
          <v-text-field
            v-model="editedItem.cuenta_bancaria.referencia"
            label="Referencia"
            outlined
            dense
            hide-details
          />
        </v-col>
        -->
        <!-- solicitud_aceptada && ids_campos_adicionales.Contains(5) -->

        <v-col
          v-if="editedItem.requisitos != null && editedItem.requisitos.length > 0"
          cols="12"
          class="pa-0 ma-0 text-center"
        >
          <br>
          <div class="text-subtitle-1 font-weight-bold">
            <v-icon>
              mdi-file-document-outline
            </v-icon>
            Documentación
          </div>
        </v-col>
        <template
          v-for="expediente_requisito in editedItem.requisitos"
        >

          <!-- en caso de  solicitud_aceptada && ids_puesto_expediente_requisitos.Contains(expediente_requisito.id_puesto_expediente_requisito) -->
          <v-col
            :key="expediente_requisito.codigo"
            cols="6"
          >
            <template v-if="expediente_requisito.tipo_documento == 1">
              <v-file-input-plus
                :urlBase="urlBase"
                dense
                accept=".jpg,.jpeg,.png,.pdf"
                :max-size="5242880"
                outlined
                :label="`${expediente_requisito.nombre} ${expediente_requisito.requerido ? '*' : ''}`"
                v-model="expediente_requisito.documento"
                :lower="true"
                :disabled="requisitoDeshabilitado(expediente_requisito)"
              ></v-file-input-plus>
              <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
            </template>

            <template v-else-if="expediente_requisito.tipo_documento == 2">
              <v-text-field
                v-model="expediente_requisito.documento"
                outlined
                dense
                hide-details
                :label="`${expediente_requisito.nombre}`"
                :disabled="requisitoDeshabilitado(expediente_requisito)"
              ></v-text-field>
              <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
            </template>
            
            <template v-else-if="expediente_requisito.tipo_documento == 3">
              <v-text-field
                v-model="expediente_requisito.documento"
                outlined
                dense
                hide-details
                :label="`${lowerFirstLetter(expediente_requisito.nombre)}`"
                :disabled="requisitoDeshabilitado(expediente_requisito)"
              ></v-text-field>
              <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
            </template>
            
            <template v-else-if="expediente_requisito.tipo_documento == 4">
              <v-text-field
                v-model="expediente_requisito.documento"
                outlined
                dense
                hide-details
                :label="`${lowerFirstLetter(expediente_requisito.nombre)}`"
                :disabled="requisitoDeshabilitado(expediente_requisito)"
              ></v-text-field>
              <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
            </template>

            <div
              v-if="expediente_requisito.observacion != null"
              class="red--text text-caption"
            >
              Motivo de rechazo: {{expediente_requisito.observacion}}
            </div>
          </v-col>
        </template>
        <v-col cols="12">
          <v-btn
            block
            color="primary"
            :loading="loadingSave"
            :disabled="loadingSave"
            @click="saveInformation"
          >
            <v-icon>mdi-content-save</v-icon>
            Actualizar Mi Expediente
            <template v-slot:loader>
              <v-progress-circular
                indeterminate
                :width="2"
                :size="24"
                color="primary"
              ></v-progress-circular>
            </template>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="pa-0 ma-0"
      >
        <v-col cols="12" class="text-center">
          <br>
          <v-progress-circular :size="100" color="primary" indeterminate></v-progress-circular>
          <br>
          <br>
          <div class="text-h5">Cargando</div>
        </v-col>
      </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapState } from "vuex";
import VFileInputPlus from '@/components/VFileInputPlus.vue';
import VAutocompleteTelefono from '@/components/VAutocompleteTelefono.vue'

export default {
  components: {
    VFileInputPlus,
    VAutocompleteTelefono
  },
  data: () => ({
    urlBase: '/api/RecursosHumanos/DescargarDocumento',
    editedItem: {
      id_empleado: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      //id_estado_civil_legal: null,
      //nombre_estado_civil_legal: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      id_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      cuenta_bancaria: {
        tipo_cuenta: 1,
        id_moneda: null,
        id_banco: null,
        nombre_beneficiario: null,
        clave_int: null,
        cuenta: null,
        cie: null,
        referencia: null,
        observacion: null
      },
      requisitos: [],
      solicitud_aceptada: false,
      ids_campos_adicionales: [],
      ids_puesto_expediente_requisitos: []
    },
    defaultEditedItem: {
      id_empleado: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      //id_estado_civil_legal: null,
      //nombre_estado_civil_legal: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      id_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      cuenta_bancaria: {
        tipo_cuenta: 1,
        id_moneda: null,
        id_banco: null,
        nombre_beneficiario: null,
        clave_int: null,
        cuenta: null,
        cie: null,
        referencia: null,
        observacion: null
      },
      requisitos: [],
      solicitud_aceptada: false,
      ids_campos_adicionales: [],
      ids_puesto_expediente_requisitos: []
    },
    loading: false,
    loadingSave: false,
    estados: [],
    loadingEstados: false,
    municipios: [],
    loadingMunicipios: false,
    parentescos: [],
    loadingParentescos: false,
    estados_civiles: [],
    loadingEstadosCiviles: false,
    creditoTipos: [],
    loadingCreditoTipos: false,
    bancos: [],
    loadingBancos: false,
    monedas: [],
    loadingMonedas: false,
    idEmpleadoPuesto: null,
    dialog: false,
    siNoOptions: [
      { text: 'Si', value: true },
      { text: 'No', value: false },
    ],
    dialogComplete: false,
  }),
  computed: {
    ...mapState(['token']),
    estadosCivilesLegales(){
      return this.estados_civiles.filter(x => x.id_estado_civil == 'beb5253b-399b-4212-8dbb-20bfd95d5160' || x.id_estado_civil == '49737087-35b6-471f-89c9-011ec163c0ce');
    }
  },
  mounted(){
    this.getEstados();
    this.getParentescos();
    this.getEstadosCiviles();
    this.getCreditoTipos();
    this.getBancos();
    this.getMonedas();
  },
  methods: {
    open(idEmpleadoPuesto){
      this.idEmpleadoPuesto = idEmpleadoPuesto;
      this.dialog = true;
      this.getItems();
    },
    close(){
      if (this.loadingSave) return;
      this.dialog = false;
      this.idEmpleadoPuesto = null;
    },
    campoAdicionalDeshabilitado(idCampo) {
      if (this.editedItem.solicitud_aceptada !== true) {
        if((this.editedItem.cuenta_bancaria.observacion != null) || (this.editedItem.requisitos.filter(r => r.observacion != null).length >= 1)) {
          if(idCampo == 5) return (this.editedItem.cuenta_bancaria.observacion == null);
          else return true;
        }
        else return false;
      }
      return !(this.editedItem.ids_campos_adicionales || []).includes(idCampo);
    },
    requisitoDeshabilitado(requisito) {
      if (this.editedItem.solicitud_aceptada !== true) {
        if((this.editedItem.cuenta_bancaria.observacion != null) || (this.editedItem.requisitos.filter(r => r.observacion != null).length >= 1)) {
          return (requisito.observacion == null);
        }
        return false;
      }
      return !(this.editedItem.ids_puesto_expediente_requisitos || []).includes(requisito.id_puesto_expediente_requisito);
    },
    getItems(){
      if (!this.idEmpleadoPuesto) return;
      this.loading = true;
      axios
      .get(`/RecursosHumanos/DetalleEmpleadoPuestoExpediente/${this.idEmpleadoPuesto}`)
      .then(response => {
        const responseData = response.data || {};

        this.editedItem = {
          ...this.defaultEditedItem,
          ...responseData,
          beneficiarios: Array.isArray(responseData.beneficiarios) ? responseData.beneficiarios : [],
           requisitos: Array.isArray(responseData.requisitos) ? responseData.requisitos : [],
           solicitud_aceptada: responseData.solicitud_aceptada === true,
           ids_campos_adicionales: Array.isArray(responseData.ids_campos_adicionales) ? responseData.ids_campos_adicionales : [],
           ids_puesto_expediente_requisitos: Array.isArray(responseData.ids_puesto_expediente_requisitos) ? responseData.ids_puesto_expediente_requisitos : [],
          nombres_tipo_credito: Array.isArray(responseData.nombres_tipo_credito) ? responseData.nombres_tipo_credito : [],
          ids_tipo_credito: Array.isArray(responseData.ids_tipo_credito) ? responseData.ids_tipo_credito : [],
          cuenta_bancaria: {
            ...this.defaultEditedItem.cuenta_bancaria,
            ...((Array.isArray(responseData.cuentas_bancarias) ? responseData.cuentas_bancarias[0] : null) || {}),
            tipo_cuenta: 1
          },
        };
        if(this.editedItem.id_estado != null) this.getMunicipios();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      })
    },
    getEstadosCiviles(){
      this.loadingEstadosCiviles = true;
      axios.get('/Catalogos/ListarEstadosCiviles')
        .then(r => { this.estados_civiles = r.data.filter(x => x.estandar == true); })
        .catch(error => { console.log(error) })
        .finally(() => { this.loadingEstadosCiviles = false; })
    },
    getCreditoTipos(){
      this.loadingCreditoTipos = true;
      axios.get('/RHCatalogos/ListarRHCreditoTipos')
        .then(r => { this.creditoTipos = r.data; })
        .catch(error => { console.log(error) })
        .finally(() => { this.loadingCreditoTipos = false; })
    },
    getBancos(){
      this.loadingBancos = true;
      axios.get('/Catalogos/ListarBancos')
        .then(response => { this.bancos = response.data; })
        .catch(error => { console.log(error) })
        .finally(() => { this.loadingBancos = false; })
    },
    codigoNombre(item) {
      return `[${item.clave}] - ${item.nombre}`;
    },
    getMonedas(){
      this.loadingMonedas = true;
      axios.get('/Catalogos/ListarMonedas')
        .then(response => { this.monedas = response.data; })
        .catch(error => { console.log(error) })
        .finally(() => { this.loadingMonedas = false; })
    },
    getParentescos(){
      this.loadingParentescos = true;
      axios
        .get('/RHCatalogos/ListarParentescos')
        .then(response => {
          this.parentescos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingParentescos = false;
        })
    },
    getEstados(){
      this.loadingEstados = true;
      axios
        .get('/Catalogos/ListarEstados')
        .then(response => {
          this.estados = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingEstados = false;
        })
    },
    getMunicipios(){
      if(this.editedItem.id_estado == null) return;
      this.loadingMunicipios = true;
      axios
        .get(`/Catalogos/ListarMunicipios/${this.editedItem.id_estado}`)
        .then(response => {
          this.municipios = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingMunicipios = false;
        })
    },
    validateInformation() {
      if(!this.editedItem.id_estado_civil){
        this.$refs.alert.setMessage("", `El estado civil es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.nss_valor || this.editedItem.nss_valor <= 0){
        this.$refs.alert.setMessage("", `El Número de Seguridad Social es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(this.editedItem.regimen_sueldos == null){
        this.$refs.alert.setMessage("", `Debe indicar si cuenta con un régimen de sueldos y salarios e ingresos asimilados a salarios.`);
        this.$refs.alert.open();
        return false;
      }

      if(this.editedItem.tiene_credito == null){
        this.$refs.alert.setMessage("", `Debe indicar si cuenta con algún crédito u obligación legal que afecte su nómina.`);
        this.$refs.alert.open();
        return false;
      }

      if(this.editedItem.tiene_credito == true && (!this.editedItem.ids_tipo_credito || this.editedItem.ids_tipo_credito.length <= 0)){
        this.$refs.alert.setMessage("", `Debe indicar cuáles tipo de crédito u obligación legal tiene.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.direccion || this.editedItem.direccion.length <= 0){
        this.$refs.alert.setMessage("", `La dirección es obligatoria.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.num_exterior || this.editedItem.num_exterior.length <= 0){
        this.$refs.alert.setMessage("", `El número exterior es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.colonia || this.editedItem.colonia.length <= 0){
        this.$refs.alert.setMessage("", `La colonia es obligatoria.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.cp || this.editedItem.cp.length <= 0){
        this.$refs.alert.setMessage("", `El código postal es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.cp || this.editedItem.cp.length <= 0){
        this.$refs.alert.setMessage("", `El código postal es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.id_estado || this.editedItem.id_estado <= 0){
        this.$refs.alert.setMessage("", `El estado es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.id_municipio){
        this.$refs.alert.setMessage("", `El municipio es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.telefono || this.editedItem.telefono.length <= 0){
        this.$refs.alert.setMessage("", `El teléfono de contacto es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.email || this.editedItem.email.length <= 0){
        this.$refs.alert.setMessage("", `El email de contacto es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.nombre_contacto_emergencia || this.editedItem.nombre_contacto_emergencia.length <= 0){
        this.$refs.alert.setMessage("", `El nombre completo del contacto de emergencia es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.telefono_contacto_emergencia || this.editedItem.telefono_contacto_emergencia.length <= 0){
        this.$refs.alert.setMessage("", `El número de celular del contacto de emergencia es obligatorio.`);
        this.$refs.alert.open();
        return false;
      }

      if(!this.editedItem.beneficiarios || this.editedItem.beneficiarios.length <= 0){
        this.$refs.alert.setMessage("", `Debe registrar al menos un beneficiario.`);
        this.$refs.alert.open();
        return false;
      }

      for (let i = 0; i < this.editedItem.beneficiarios.length; i++) {
        const beneficiario = this.editedItem.beneficiarios[i];

        if (!beneficiario.nombre_completo || beneficiario.nombre_completo <= 0) {
          this.$refs.alert.setMessage("", `Debe registrar el nombre completo del beneficiario en el renglón ${i+1}.`);
          this.$refs.alert.open();
          return false;
        }

        if (!beneficiario.telefono || beneficiario.telefono <= 0) {
          this.$refs.alert.setMessage("", `Debe registrar el teléfono del beneficiario en el renglón ${i+1}.`);
          this.$refs.alert.open();
          return false;
        }

        if (!beneficiario.id_parentesco) {
          this.$refs.alert.setMessage("", `Debe registrar el parentesco del beneficiario en el renglón ${i+1}.`);
          this.$refs.alert.open();
          return false;
        }
      }

      const cuenta = this.editedItem.cuenta_bancaria || {};
      if (!cuenta.id_banco) {
        this.$refs.alert.setMessage("", 'Debe seleccionar el banco de nómina.');
        this.$refs.alert.open();
        return false;
      }

      if (!cuenta.clave_int || String(cuenta.clave_int).length > 18) {
        this.$refs.alert.setMessage("", 'Debe ingresar una CLABE interbancaria entre 1 y 18 caracteres.');
        this.$refs.alert.open();
        return false;
      }

      if (!cuenta.cuenta || String(cuenta.cuenta).length > 18) {
        this.$refs.alert.setMessage("", 'Debe ingresar una cuenta entre 1 y 18 caracteres.');
        this.$refs.alert.open();
        return false;
      }

      const requisitos = Array.isArray(this.editedItem.requisitos) ? this.editedItem.requisitos : [];

      for (let i = 0; i < requisitos.length; i++) {
        const requisito = requisitos[i];

        const tieneDocumento = requisito.documento instanceof File
          ? requisito.documento.size > 0
          : typeof requisito.documento === 'string' && requisito.documento.trim().length > 0;
        if (!this.requisitoDeshabilitado(requisito) && requisito.requerido === true && !tieneDocumento) {
          this.$refs.alert.setMessage("", `El ${this.lowerFirstLetter(requisito.nombre).replace(' *', '')} es obligatorio.`);
          this.$refs.alert.open();
          return false;
        }
      }
      return true;
    },
    formatMoney(number) {
      if(!number) return "";
      // Convierte el número a un string con dos decimales
      let numberString = number.toFixed(2);

      // Usa una expresión regular para agregar comas cada tres dígitos
      let formattedNumber = "$"+numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return formattedNumber;
    },
    saveInformation(){
      if(!this.validateInformation()) return;      
      this.loadingSave = true;

      // Convierte los campos de `this.editedItem` en entradas de `FormData`
      const formData = new FormData();
      // Campos simples
      formData.append('id_estado_civil', this.editedItem.id_estado_civil);
      formData.append('nss_valor', this.editedItem.nss_valor);
      formData.append('regimen_sueldos', this.editedItem.regimen_sueldos);
      formData.append('tiene_credito', this.editedItem.tiene_credito);
      if (this.editedItem.tiene_credito === true &&
          Array.isArray(this.editedItem.ids_tipo_credito) &&
          this.editedItem.ids_tipo_credito.length > 0) {

        this.editedItem.ids_tipo_credito.forEach((id, index) => {
          formData.append(`ids_tipo_credito[${index}]`, id);
        });
      }

      formData.append('direccion', this.editedItem.direccion);
      formData.append('num_exterior', this.editedItem.num_exterior);
      if(this.editedItem.num_interior) formData.append('num_interior', this.editedItem.num_interior);
      formData.append('colonia', this.editedItem.colonia);
      formData.append('cp', this.editedItem.cp);
      formData.append('id_estado', this.editedItem.id_estado);
      formData.append('id_municipio', this.editedItem.id_municipio);
      formData.append('telefono', this.editedItem.telefono);
      formData.append('email', this.editedItem.email);
      formData.append('nombre_contacto_emergencia', this.editedItem.nombre_contacto_emergencia);
      formData.append('telefono_contacto_emergencia', this.editedItem.telefono_contacto_emergencia);

      const cuenta = this.editedItem.cuenta_bancaria;
      formData.append('cuenta_bancaria.tipo_cuenta', '1');
      formData.append('cuenta_bancaria.id_banco', cuenta.id_banco);
      formData.append('cuenta_bancaria.clave_int', cuenta.clave_int);
      formData.append('cuenta_bancaria.cuenta', cuenta.cuenta);
      if (cuenta.cie) formData.append('cuenta_bancaria.cie', cuenta.cie);
      if (cuenta.referencia) formData.append('cuenta_bancaria.referencia', cuenta.referencia);

      // Lista: beneficiarios
      this.editedItem.beneficiarios.forEach((b, index) => {
        const prefix = `beneficiarios[${index}]`;

        if (b.id_empleado_beneficiario) {
          formData.append(`${prefix}.id_empleado_beneficiario`, b.id_empleado_beneficiario);
        }

        formData.append(`${prefix}.nombre_completo`, b.nombre_completo);
        formData.append(`${prefix}.telefono`, b.telefono);
        formData.append(`${prefix}.id_parentesco`, b.id_parentesco);
      });

      // Lista: requisitos_archivos (IFormFile)
      (Array.isArray(this.editedItem.requisitos) ? this.editedItem.requisitos : [])
        .filter(x => x.tipo_documento === 1 && x.documento instanceof File && !!x.documento.name && x.documento.size > 0)
        .forEach((r, index) => {
          const prefix = `requisitos_archivos[${index}]`;

          formData.append(`${prefix}.id_expediente_requisito`, r.id_expediente_requisito);

          // IMPORTANTE: aquí va el File como "documento", que es IFormFile en C#
          formData.append(`${prefix}.documento`, r.documento);
          formData.append(`${prefix}.eliminar`, 'false');
        });

      // Lista: requisitos_otros (texto)
      (Array.isArray(this.editedItem.requisitos) ? this.editedItem.requisitos : [])
        .filter(x => x.tipo_documento !== 1 && x.documento != null)
        .forEach((r, index) => {
          const prefix = `requisitos_otros[${index}]`;

          formData.append(`${prefix}.id_expediente_requisito`, r.id_expediente_requisito);
          formData.append(`${prefix}.documento`, r.documento);
          formData.append(`${prefix}.eliminar`, 'false');
        });

      axios({
        method: 'POST',
        url: `/RecursosHumanos/ActualizarExpediente/${this.idEmpleadoPuesto}`,
        data: formData
      })
      .then(() => {
        this.dialogComplete = true;
      })
      .catch(error => {
        const mensaje = error.response?.data?.msg || error.response?.data?.Msg
          || 'No se pudo enviar el expediente. Revise la documentación e inténtelo nuevamente.';
        this.$refs.alert.setMessage('No se envió el expediente', mensaje);
        this.$refs.alert.open();
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
    changeEstado(){
      this.getMunicipios();
      this.editedItem.id_municipio = null;
    },
    addBeneficiario() {
      if (this.editedItem.beneficiarios.length >= 2) {
        this.$refs.alert.setMessage("", `Solo se permiten dos beneficiarios como máximo.`);
        this.$refs.alert.open();
        return;
      }

      this.editedItem.beneficiarios.push({
        id_empleado_beneficiario: null,
        nombre_completo: null,
        telefono: null,
        id_parentesco: null,
      });
    },
    removeBeneficiario(i) {
      this.editedItem.beneficiarios.splice(i, 1);
    },
    changeCredit(){
      if(!this.editedItem.tiene_credito) this.editedItem.ids_tipo_credito = [];
    },
    lowerFirstLetter(text) {
      if (!text) return text; // Maneja null, undefined o string vacío

      // Si inicia con CURP, regresamos el texto tal cual
      if (text.startsWith("CURP")) return text;

      return text.charAt(0).toLowerCase() + text.slice(1);
    },
    cerrarDialogo(){
      this.dialogComplete = false;
      this.dialog = false;
      this.idEmpleadoPuesto = null;
      this.$emit('saved');
    }
  }
};
</script>
